export default "__VITE_ASSET__DMlaEBMW__"